import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp8};
  background-color: ${props => props.theme.colors.background.secondary};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius1};

  button {
    border: none;
    background-color: transparent;
    padding: ${props => props.theme.spacing.sp4};
  }
`

export const Code = styled.div`
  min-width: 0;
  white-space: pre-wrap;
  word-break: break-all;
`
